import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getParserConfigList = (deviceTypeId?: number) =>
  axiosInstance.get(API_ENDPOINTS.getParserConfigList, {
    params: deviceTypeId !== undefined ? { deviceTypeId } : undefined,
  });

export const getParserConfigPaginate = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.getParserConfigPaginate, payload);

export const getParserConfigById = (id: string) =>
  axiosInstance.get(API_ENDPOINTS.getParserConfig(id));

export const createParserConfig = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.createParserConfig, payload);

export const updateParserConfig = (payload: any) =>
  axiosInstance.put(API_ENDPOINTS.updateParserConfig, payload);

export const parserConfigReport = (payload: { payload: string; parserConfigId: number }) =>
  axiosInstance.post(API_ENDPOINTS.parserConfigReport, payload);
